// Zeitwarnung Techniker (hawk#608): Minuten ab ONSITE, nach denen die App den Techniker warnt.
// Leer = kein Timer, daher wird ein leeres Feld als null an die API gesendet.

// Normalisiert die Formulareingabe: leer → null, sonst die Zahl
export function normalizeTimeWarningTechnician(value: unknown): number | null {
  if (value === null || value === undefined || value === '') {
    return null
  }
  const minutes = Number(value)
  return Number.isNaN(minutes) ? null : minutes
}

// Gültig sind nur leer oder eine ganze Zahl > 0
export function isValidTimeWarningTechnician(value: unknown): boolean {
  const minutes = normalizeTimeWarningTechnician(value)
  if (minutes === null) {
    return value === null || value === undefined || value === ''
  }
  return Number.isInteger(minutes) && minutes > 0
}
